import React from 'react';
import { useTranslation } from 'react-i18next';
import { RELEASE_NAME } from '../../core/config';
import { Spacer } from '../spacer/spacer';
import { Typography } from '../typography/typography';
import styles from './error-section.module.scss';

type Props = {
  // Optional untranslated information to aid in pinpointing the precise location of the error.
  debugInfo?: string;
  error: Error | null | unknown;
  title?: string;
};

export const ErrorSection: React.FC<Props> = ({ debugInfo, error, title }) => {
  const { t } = useTranslation();
  const errorMsg = error instanceof Error ? error?.message : null;
  return (
    <div className={styles.root}>
      {title ? (
        <Typography className={styles.title} variant="headline-3">
          {title}
        </Typography>
      ) : null}
      {errorMsg ? (
        <>
          <Spacer size="02" />
          <Typography color="anthrazit" variant="maintext">
            {errorMsg}
          </Typography>
        </>
      ) : null}
      <Spacer size="04" />
      <Typography color="black" variant="smalltext">
        {t('global.debugInformation')}
      </Typography>
      <Spacer size="02" />
      <Typography color="anthrazit" variant="smalltext">
        {`${t('global.appVersion')}: ${RELEASE_NAME}`}
      </Typography>
      <Spacer size="02" />
      <Typography color="anthrazit" variant="smalltext">
        {`Timestamp UTC: ${new Date().toUTCString()}`}
      </Typography>
      {debugInfo ? (
        <>
          <Spacer size="02" />
          <Typography color="anthrazit" variant="smalltext">
            {`Debug Info: ${debugInfo}`}
          </Typography>
        </>
      ) : null}
    </div>
  );
};
